import { Tab, Tabs } from "@itwin/itwinui-react";
import React from "react";
import { useState } from "react";
import styles from "./dialog-tabs.module.css"

export const DialogTabs = ({ children }: { children: React.ReactNode }) => {
  const [tabSelected, setTabSelected] = useState(0);

  const panels = React.Children.toArray(children);

  return (
    <Tabs
      labels={[
        <Tab key={1} label="General" data-testid="atp-general-tab"/>,
        <Tab key={2} label="Helper Files" data-testid="atp-helper-files-tab"/>,
      ]}
      type="borderless"
      onTabSelected={setTabSelected}
    >
      <>
        <div className={tabSelected === 0 ? "" : styles.hidden} data-testid="atp-sandbox-general">
          {panels[0]}
        </div>
        <div className={tabSelected === 1 ? "" : styles.hidden} data-testid= "atp-helper-files">
          {panels[1]}
        </div>
      </>
    </Tabs>
  );
}